import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import ArrowBack from '@mui/icons-material/ArrowBack';
import PageHeader from '../../../Components/PageHeader';
import { useApiGet } from '../../../utils/httpClientTs';
import { getOnlineItem } from '../../../endpoints/chapterSupplies';

export default function OnlineItemDetail() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const { data: detail, isFetching } = useApiGet(
    ['chapter-supplies-online-item', id],
    () => getOnlineItem(id!),
    { enabled: !!id, retry: 1 }
  );

  if (!id) {
    return (
      <Grid container paddingLeft={2} paddingRight={2}>
        <Typography color="error">Missing online item ID.</Typography>
      </Grid>
    );
  }

  if (isFetching && !detail) {
    return (
      <Grid container paddingLeft={2} paddingRight={2}>
        <Typography>Loading…</Typography>
      </Grid>
    );
  }

  if (!detail) {
    return (
      <Grid container paddingLeft={2} paddingRight={2}>
        <Typography color="error">Online item not found.</Typography>
      </Grid>
    );
  }

  return (
    <Grid container paddingLeft={2} paddingRight={2}>
      <Grid item xs={12}>
        <PageHeader
          title={detail.item_name ?? 'Online item'}
          leftDom={
            <Button
              startIcon={<ArrowBack />}
              onClick={() =>
                navigate('/chapter-supplies-management/online-items')
              }
            >
              Back to list
            </Button>
          }
          rightDom={undefined}
          subtitle={undefined}
        />
      </Grid>
      <Grid item xs={12} sx={{ mt: 2 }}>
        <Paper sx={{ p: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Typography variant="caption" color="text.secondary">
                Item
              </Typography>
              <Typography variant="body1">
                {detail.item_name ?? '—'} ({detail.item_id})
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="caption" color="text.secondary">
                Price
              </Typography>
              <Typography variant="body1">
                {typeof detail.price === 'number'
                  ? `$${detail.price.toFixed(2)}`
                  : '—'}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="caption" color="text.secondary">
                Featured
              </Typography>
              <Typography variant="body1">
                {detail.is_featured === 1 ? 'Yes' : 'No'}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="caption" color="text.secondary">
                Discontinued
              </Typography>
              <Typography variant="body1">
                {detail.is_discontinued === 1 ? 'Yes' : 'No'}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="caption" color="text.secondary">
                Short description
              </Typography>
              <Typography variant="body1">
                {detail.short_description ?? '—'}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="caption" color="text.secondary">
                Image URL
              </Typography>
              <Typography variant="body1">{detail.image_url ?? '—'}</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="caption" color="text.secondary">
                Sort order
              </Typography>
              <Typography variant="body1">
                {detail.sort_order ?? '—'}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="caption" color="text.secondary">
                Category IDs
              </Typography>
              <Typography variant="body1">
                {detail.category_ids?.length
                  ? detail.category_ids.join(', ')
                  : '—'}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="caption" color="text.secondary">
                Subcategory IDs
              </Typography>
              <Typography variant="body1">
                {detail.sub_category_ids?.length
                  ? detail.sub_category_ids.join(', ')
                  : '—'}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="caption" color="text.secondary">
                Group type IDs
              </Typography>
              <Typography variant="body1">
                {detail.group_type_ids?.length
                  ? detail.group_type_ids.join(', ')
                  : '—'}
              </Typography>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
}
